import type {
  ApprovedLoginLocation,
  FormData,
} from './approved-login-locations-form-values';

export const toFormData = (values?: ApprovedLoginLocation): FormData => {
  return {
    country: values?.country ?? '',
    duration: [values?.start, values?.expiry],
  };
};
export const fromFormData = (formData: FormData): ApprovedLoginLocation => {
  return {
    country: formData.country,
    start: formData.duration?.[0],
    expiry: formData.duration?.[1],
  };
};
